import { useSearchParams } from "react-router-dom";
import PasswordResetFlow from "../components/PasswordResetFlow";

// Legacy entry point used by reset-password email links: drops users straight
// into the "enter code + new password" step with their email pre-filled.
export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  return (
    <PasswordResetFlow
      initialStep="reset"
      initialEmail={searchParams.get("email") || ""}
    />
  );
}
